import axios from "axios";
import * as actions from "./actionTypes";
import messages from "../../messages";
import toastr from "toastr";
import PlantillaCompetenciaServices from "./plantillaCompetencia.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const resetPlantillaCompetencias = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_PLANTILLA_COMPETENCIA,
      payload: true,
    });
    dispatch({
      type: actions.GET_PLANTILLA_COMPETENCIA,
      payload: {data:[],count:0, all:[]}, 
    });
    dispatch({
      type: actions.PLANTILLA_COMPETENCIA_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.PLANTILLA_COMPETENCIA_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_PLANTILLA_COMPETENCIA,
      payload: false,
    });
  }
};

export const getPlantillaCompetencias = filters => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_PLANTILLA_COMPETENCIA,
      payload: true,
    });
    const resp = await PlantillaCompetenciaServices.getPlantillaCompetencias(filters);
    // const resp2 = await PlantillaCompetenciaServices.getPlantillaCompetencias({tipo_busqueda:filters.tipo_busqueda,filter:filters.filter});
    let _resp = resp;
    _resp.data.all = resp.data.data_año
    dispatch({
      type: actions.GET_PLANTILLA_COMPETENCIA,
      payload: _resp.data,
    });
    dispatch({
      type: actions.PLANTILLA_COMPETENCIA_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.PLANTILLA_COMPETENCIA_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_PLANTILLA_COMPETENCIA,
      payload: false,
    });
  }
};

export const getPlantillaCompetencia = id => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_PLANTILLA_COMPETENCIA,
      payload: true,
    });
    const resp = await PlantillaCompetenciaServices.getPlantillaCompetencia(id);
    dispatch({
      type: actions.GET_PLANTILLA_COMPETENCIA,
      payload: resp.data,
    });
    dispatch({
      type: actions.PLANTILLA_COMPETENCIA_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.PLANTILLA_COMPETENCIA_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_PLANTILLA_COMPETENCIA,
      payload: false,
    });
  }
};

export const savePlantillaCompetencia = (req, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_PLANTILLA_COMPETENCIA,
      payload: true,
    });
    const resp = await PlantillaCompetenciaServices.savePlantillaCompetencia(req);
    const { data, count, all } = getState().plantillaCompetencia.plantillaCompetencia;
    dispatch({
      type: actions.GET_PLANTILLA_COMPETENCIA,
      payload: {
        count: count + 1,
        data: [...data, resp.data],
        all: [...all, {clasificacion:resp.data.list_periodicidad[0].clasificacion}],
      },
    });
    dispatch({
      type: actions.FORM_PLANTILLA_COMPETENCIA_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data&&ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = ex.response.data[0];
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_PLANTILLA_COMPETENCIA_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_PLANTILLA_COMPETENCIA,
      payload: false,
    });
  }
};

export const editPlantillaCompetencia = (req, id, index, setShowModal, offset) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_PLANTILLA_COMPETENCIA,
      payload: true,
    });
    const resp = await PlantillaCompetenciaServices.editPlantillaCompetencia(id, req);
    const { data, count, all } = getState().plantillaCompetencia.plantillaCompetencia;
    let _data = data.slice();
    _data[index] = resp.data;
    // let _all = all.slice();
    // _all[index-offset] = resp.data;
    dispatch({
      type: actions.GET_PLANTILLA_COMPETENCIA,
      payload: {
        data: _data,
        count: count,
        all: all
      },
    });
    dispatch({
      type: actions.FORM_PLANTILLA_COMPETENCIA_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data&&ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = ex.response.data[0];
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_PLANTILLA_COMPETENCIA_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_PLANTILLA_COMPETENCIA,
      payload: false,
    });
  }
};

export const copyCompetencyTemplate = (_data,setShowModalCopy) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_PLANTILLA_COMPETENCIA,
      payload: true,
    });
    const resp = await PlantillaCompetenciaServices.copyCompetencyTemplate(_data);
    const { data, count, all } = getState().plantillaCompetencia.plantillaCompetencia;
    const _resp = resp.data
    if(_resp.data.length>0){
      _resp.data.map(item=>{
        data.push(item)
        all.push(item)
      })
    }
    dispatch({
      type: actions.GET_PLANTILLA_COMPETENCIA,
      payload: {
        count: count + 1,
        data: data,
        all: all,
      },
    });
    dispatch({
      type: actions.FORM_COPY_PLANTILLA_COMPETENCIA_FAIL,
      payload: _resp.respuestas_fallidas!==""||!_resp.respuestas_fallidas?_resp.respuestas_fallidas:"",
    });
    if(_resp.respuestas_fallidas===""||!_resp.respuestas_fallidas){
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      setShowModalCopy(false)
    }
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            if(ex.response.data.Resultado){
              message = ex.response.data.Resultado;
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    // dispatch({
    //   type: actions.FORM_FAIL,
    //   payload: message,
    // });
    toastr.error(message)
    dispatch({
      type: actions.FORM_COPY_PLANTILLA_COMPETENCIA_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_PLANTILLA_COMPETENCIA,
      payload: false,
    });
  }
};

export const deletePlantillaCompetencia = (id, index, offset) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_PLANTILLA_COMPETENCIA,
      payload: true,
    });
    await PlantillaCompetenciaServices.deletePlantillaCompetencia(id);
    const { data, count, all } = getState().plantillaCompetencia.plantillaCompetencia;
    let _data = data.slice();
    _data.splice(index, 1);
    // let _all = all.slice();
    // _all.splice(index+offset, 1);
    dispatch({
      type: actions.GET_PLANTILLA_COMPETENCIA,
      payload: {
        data: _data,
        count: count - 1,
        all: all
      },
    });
    dispatch({
      type: actions.PLANTILLA_COMPETENCIA_FALLA,
      payload: '',
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.PLANTILLA_COMPETENCIA_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_PLANTILLA_COMPETENCIA,
      payload: false,
    });
  }
};